import { TCreateTeaserSelectedItem } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetRestaurantsShort, IGetRestaurantsShortArgs } from 'types';
import { getRestaurantsShortInfo } from 'backend/restaurants';
import { useFetchData } from 'hooks/useFetchData';
import MultipleSelect from './components/MultipleSelect';
import style from './RestaurantsMultipleSelect.module.scss';

interface IRestaurantsMultipleSelect {
	selectedRestaurants: string[];
	selectedCustomer: TCreateTeaserSelectedItem;
	setRestaurants: (value: string[]) => void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

const RestaurantsMultipleSelect: React.FC<IRestaurantsMultipleSelect> = ({
	selectedRestaurants,
	selectedCustomer,
	setRestaurants,
	setFetchedRestaurants,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetRestaurantsShort, IGetRestaurantsShortArgs>(
		selectedCustomer ? getRestaurantsShortInfo : null,
		{
			customerId: selectedCustomer || '',
		},
	);

	useEffect(() => {
		refetch();
	}, [selectedCustomer]);

	useEffect(() => {
		if (response) {
			setFetchedRestaurants(response.data.restaurants);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.restaurants || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedRestaurants={selectedRestaurants}
					selectedCustomer={selectedCustomer}
					setRestaurants={setRestaurants}
				/>
			</div>
		</div>
	);
};

export default React.memo(RestaurantsMultipleSelect);
